/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./DebugBar.css";

// Developer-only overlay for stepping through the three workspaces without an
// account of each type. Opt in with ?debug=1 (and off again with ?debug=0);
// the choice is remembered in localStorage for the rest of the session, so a
// visitor never sees this unless they ask for it by hand. Deliberately not
// localised — it is a tool, not product copy.
//
// It sits collapsed to a single letter — the account type currently being
// forced — and opens on hover, so it never covers the page it is inspecting.
class DebugBar extends Component {
  render() {
    const vm = this.props.vm;
    const active = vm.debugPersonas.find((p) => p.active);
    return (
      <div className="Marketplace-Debug">
        <div className="Marketplace-Debug-handle">{active ? active.label[0] : "D"}</div>
        <div className="Marketplace-Debug-body">
          <span className="Marketplace-Debug-label">DEBUG · ACCOUNT TYPE</span>
          <div className="Marketplace-Debug-tabs">
            {vm.debugPersonas.map((p) => (
              <div
                className={"Marketplace-Debug-tab" + (p.active ? " Marketplace-Debug-tab--active" : "")}
                onClick={p.pick}
                key={p.id}
              >
                {p.label}
              </div>
            ))}
          </div>
          <span className="Marketplace-Debug-close" onClick={vm.closeDebug}>
            ×
          </span>
        </div>
      </div>
    );
  }
}

DebugBar.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default DebugBar;
